import axios from "axios";
import { Message } from "element-ui";
import store from "@/store/index";
import { dict, utils } from "@/utils/index.js";
// 随机数生成
function RondomPass(number) {
  var arr = [];
  var arr1 = Array.of("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
  for (var i = 0; i < number; i++) {
    var n = Math.floor(Math.random() * 10);
    arr[i] = arr1[n];
  }
  return arr.join("");
}

// UTC时间
function UTCTime() {
  return parseInt(new Date().getTime() / 1000);
}
const CryptoJS = require("crypto-js");
const cryptoObject = CryptoJS.AES.encrypt('data', 'key');
console.log('CryptoJS:', cryptoObject);
const _host = "cmsauth.baowugroup.com";
const _port = "";
const _protocol = window.location.protocol;
//获取用户token，如果没有，跳转到登录页面
// 创建axios实例
const ajax = axios.create({
  baseURL: dict.API_URL,
  withCredentials: true // 允许携带cookie
});
// 添加请求拦截器
ajax.interceptors.request.use(
  function (config) {
    let xNonce = RondomPass(10);
    let xDate = UTCTime();
    let contentMd5 = CryptoJS.MD5(
      JSON.stringify(config.data ? config.data : "")
    ).toString(CryptoJS.enc.Hex);
    let signString = "";
    let userHash = "";
    let passHash = "13ade1de1eff43ffb821735f352a4148";
    if (localStorage.getItem("userInfo")) {
      userHash = `2/${JSON.parse(localStorage.getItem("userInfo")).token}`;
      let pwd = JSON.parse(localStorage.getItem("userInfo")).pwd;
      passHash = pwd;
    } else {
      userHash = "0/56f5cff3cad14853a44782c2c689ab2a";
      passHash = "13ade1de1eff43ffb821735f352a4148";
    }
    config.headers["x-user"] = userHash;
    config.headers["x-nonce"] = xNonce;
    config.headers["x-date"] = xDate;
    config.headers["Content-Md5"] = contentMd5;
    config.url = config.url + "?domainId=31";
    signString = `${config.method.toUpperCase()}\n${config.url.replace(
      _protocol + "//" + _host + ":" + _port,
      ""
    )}\nx-user:${userHash}\nx-nonce:${xNonce}\nx-date:${xDate}\nContent-Md5:${contentMd5}\n`;
    let signatureString = CryptoJS.HmacSHA1(signString, passHash)
      .toString()
      .toUpperCase();
    // console.log(signatureString)
    config.headers["x-signature"] = signatureString;

    var debug = utils.getUrlParams("debug");
    config.baseURL = debug ? debug : dict.SETTING.API_URL;
    config.headers.Authorization = store.getters.token;
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 添加响应拦截器
ajax.interceptors.response.use(
  function (response) {
    if (typeof response.data == "string") {
      try {
        response.data = JSON.parse(response.data);
      } catch (err) {
        Message({
          showClose: true,
          message: "JSON格式错误！",
          type: "error"
        });
      }
    }
    if (response.status != 200) {
      Message({
        showClose: true,
        message: "接口错误，错误码" + response.status,
        type: "error"
      });

      return response;
    }
    // if (response.data.code == 2) {
    //   store.dispatch("user/loginOut").then(() => {
    //     Message({
    //       message: "登陆超时",
    //       type: "info",
    //       duration: 5 * 1000
    //     });
    //     location.reload();
    //   });
    // }
    // if (response.data.code == 3) {
    //   Message({
    //     message: "无权限！",
    //     type: "warning",
    //     duration: 5 * 1000
    //   });
    // }
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    // console.warn("请求错误", error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);
export default ajax;
